<template lang="pug">
.wait_wap(v-if='isShow')
  .wait_wap_contain
    .wait_wap_content
      img.wait_logo(src='/static/images/wait_tip.png')
      p.wait_he 同学你好：
      .wait_wap_content_item
        p 因本时间段内，在线学习人数较多，为了保证每个学生的答题体验以及系统稳定，我们建议您
        span 10分钟
        p 后， 再次访问“驰声听说在线”网站尝试，开始你的听说学习之旅~
      .wait_wap_content_tip tip：该情况在线客服已知悉，无需重复告知
      .wait_wap_content_img
        img(src='/static/images/wait_normal.png')
    .wait_wap_footer
      .wait_wap_footer_btn(@click='handleQuit') 
        p 稍后，再来学习
      .wait_wap_footer_tip(@click='handleQueue') 没关系，我想排队等候

  km-dialog.correct_dialog_queueUp(
    :visible.sync='visible',
    :isCenter='true',
    :showClose='isQueue',
    :class='{ correct_dialog_queueUp_sure: isQueue === false }',
    @close='handleCloseDialog'
  )
    .correct_title(slot='title')
      p {{ modeName }}
    .correct_body(slot='body', v-if='isQueue')
      img(src='/static/images/wait_gif.gif')
      .correct_body_tips 抱歉，目前排队人数较多，请您耐心等待，很多美好的东西，都需要耐心等待~
    .correct_body(slot='body', v-else)
      p.close_text 是否确认关掉网页？
      .close_tips tip:请隔断时间，重新访问听说在线网页 即可继续听说学习之旅~
    .correct_footer(slot='footer', v-if='!isQueue')
      .btn.cancel(@click='handleCancel') 取消
      .btn.sure(@click='handleSureQuit') 确认退出
</template>

<script>
// import { gateway } from '@/api'
import { KmDialog } from '@/ui/src/index'
export default {
  components: { KmDialog },
  data() {
    return {
      resolve: () => {},
      reject: () => {},
      visible: false,
      isQueue: false,
      isShow: false,
      timeout: '',
      studentId: localStorage.getItem('studentId'),
    }
  },
  computed: {
    modeName() {
      if (this.isQueue) {
        return '正在排队，请稍后...'
      } else {
        return '提示'
      }
    },
  },
  methods: {
    handleCloseDialog() {
      clearTimeout(this.timeout)
    },
    loginHeart() {
      if (localStorage.getItem('gatewayUrl')) {
        fetch(
          `${localStorage.getItem('gatewayUrl')}/api/gateway?stuId=${
            this.studentId ? this.studentId : ''
          }&token=${new Date().getTime()}`
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 'fail') {
              this.timeout = setTimeout(() => {
                this.loginHeart()
              }, 300000)
            } else {
              window.location.reload()
            }
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        window.location.href = window.ConfigNew.login
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleQuit() {
      this.visible = true
      this.isQueue = false
    },
    handleQueue() {
      this.visible = true
      this.isQueue = true
      this.loginHeart()
    },
    handleSureQuit() {
      this.visible = false
      this.$toast({
        text: '请手动关闭该网页',
        showWrap: false,
        iconFlag: false,
        duration: 1000,
        styleObj: {
          width: '140px',
          height: '50px',
          'border-radius': '4px',
          'background-color': 'rgba(0, 0, 0, 0.6)',
        },
      })
    },
  },
  mounted() {
    if (localStorage.getItem('gatewayUrl')) {
      fetch(
        `${localStorage.getItem('gatewayUrl')}/api/gateway?stuId=${
          this.studentId ? this.studentId : ''
        }&token=${new Date().getTime()}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'fail') {
            this.isShow = true
          } else {
            this.resolve()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      window.location.href = window.ConfigNew.login
    }
  },
}
</script>

<style lang="less" scoped>
.wait_wap {
  width: 1366px;
  height: 768px;
  background-color: #fff;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .wait_wap_contain {
    width: 739px;
    .wait_wap_content {
      .wait_logo {
        display: block;
      }
      .wait_he {
        font-size: 20px;
        color: #666;
        margin-top: 20px;
        text-align: left;
      }
      .wait_wap_content_item {
        margin-top: 10px;
        p {
          display: inline-block;
          font-size: 16px;
        }
        span {
          color: #21bd73;
          font-size: 16px;
          font-weight: bold;

          font-family: Microsoft YaHei;
        }
      }
      .wait_wap_content_tip {
        font-size: 16px;
        margin-top: 20px;
      }
      .wait_wap_content_img {
        margin-top: 40px;
        text-align: center;
      }
    }
    .wait_wap_footer {
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .wait_wap_footer_btn {
        display: flex;
        align-items: center;
        cursor: pointer;
        p {
          width: 274px;
          height: 52px;
          background: #21bd73;
          opacity: 1;
          border-radius: 30px;
          text-align: center;
          line-height: 52px;
          color: #fff;
          font-size: 20px;
        }
      }
      .wait_wap_footer_tip {
        font-size: 16px;
        color: #999999;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
  .correct_dialog_queueUp {
    .correct_title {
      p {
        font-size: 20px;
        color: #333;
      }
    }
    .correct_body {
      margin-top: 30px;
      img {
        width: 267px;
        height: 104px;
      }
      .correct_body_tips {
        width: 314px;
        height: 42px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 21px;
        color: #666666;
        opacity: 1;
        margin-top: 20px;
      }
      .close_text {
        font-size: 16px;
        color: #333;
      }
      .close_tips {
        width: 246px;
        height: 38px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #999999;
        opacity: 1;
        margin-top: 10px;
        margin-left: 30px;
      }
    }
    .correct_footer {
      .sure {
        background-color: #21bd73;
        color: #fff;
        margin-left: 30px;
      }
    }
  }
}
</style>
<style>
.correct_dialog_queueUp_sure .content {
  min-height: auto !important;
  height: 256px;
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/queueUp/app.vue